import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SearchActions } from 'src/app/common/store/actions/search.actions';

import { selectAllSearchedCarsPreviewTotalCount, selectAllSearchedDealersPreviewTotalCount, selectBusinessLine, selectDealerFavorites, selectRecentCarBriefs, selectSearchFetchingPreview, selectSelectedCountryCodes } from 'src/app/common/store/state/app.state';
import { selectMakes, selectModels, selectVersions } from 'src/app/common/store/state/app.state';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { DateRange } from '@angular/material/datepicker';
import { DealerCriteria } from '../account/models/dealer-criteria.model';
import { CarBrief } from '../car/models/car-brief.model';
import { CarCriteria } from '../car/models/car-criteria.model';
import { CarMake } from '../car/models/car-make.model';
import { CarModel } from '../car/models/car-model.model';
import { CarVersion } from '../car/models/car-version.model';
import { AppConstants } from '../common/constants/app-constants';
import { CarBusinessLine, CarBasicData } from '../car/constants/car-basic-data';
import { CommonBasicData, ServiceType } from '../common/constants/common-basic-data';
import { GeneralBasicData } from '../common/constants/general-basic-data';
import { Appointment } from '../common/models/appointment.model';
import { Country } from '../common/models/country.model';
import { QuickLinks } from '../common/models/quick-links.model';
import { LocationService } from '../common/services/location-service';
import { KeepBasicData } from '../keep/constants/keep-basic-data';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent  {

  recentCarBriefs$: Observable<CarBrief[]>;
  recentCarBriefs: CarBrief[] = [];

  defaultCountry: Country = GeneralBasicData.getDefaultCountry();

  selectedCountryCodes$: Observable<string[]>;
  selectedCountry: Country = GeneralBasicData.getDefaultCountry();

  businessLinesBD : string [] = [CarBusinessLine.BUY, CarBusinessLine.RENT];
  gearboxesBD = CarBasicData.gearboxes;
  serviceTypesBD = CommonBasicData.serviceTypes;

  quickLinks: QuickLinks[] = [
    new QuickLinks("TOYOTA", ["Yaris", "Altezza", "RAV4", "Corolla", "Allion"]),
    new QuickLinks("MERCEDES", ["C320", "4Matic", "170", "Classe S", "180"]),
    new QuickLinks("BMW", ["I7", "I8", "Serie 8", "Serie M", "Serie X"]),
    new QuickLinks("HYUNDAI", ["IONIQ", "Santa Fe", "Tucson", "Elantra"]),
    new QuickLinks("VOLKSWAGEN", ["Polo", "Touareg", "Golf", "Arteon"])
  ];

  carMakesBD: string [] = [];
  carModelsBD: string [] = [];

  makes$: Observable<CarMake[]>;
  models$: Observable<CarModel[]>;
  versions$: Observable<CarVersion[]>;

  selectedMakes: CarMake[] = [] ;
  selectedModels: CarModel[] = [] ;
  selectedVersions: CarVersion[] = [] ;

  countriesBD: Country [] = [];
  citiesBD: string [] = [];

  carCriteria: CarCriteria = new CarCriteria();
  appointment: Appointment = new Appointment();

  fetchingPreview$: Observable<boolean>;
  carsPreviewTotalCount$: Observable<number>;
  dealersPreviewTotalCount$: Observable<number>;

  businessLine$: Observable<CarBusinessLine>;

  CarBusinessLine = CarBusinessLine;
  ServiceType = ServiceType;

  jobCategoriesBD = KeepBasicData.carJobCategories;

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;
  selectedDateRange: DateRange<Date>;


  valuePropositions = {
    "BUY" : [
      {icon: "directions_car", text:"&nbsp; &nbsp; 3000 véhicules, &nbsp; &nbsp; 34 marques"}, 
      {icon: "today", text:"&nbsp; Garantie 12 mois &nbsp;  et plus"}, 
      {icon: "flag_2", text:"30 jours d'éssai, Retours gratuits"}, 
      {icon: "settings_heart", text:"&nbsp;&nbsp; Carnet &nbsp;&nbsp;d'entretien"}
    ],
    "RENT" : [
      {icon: "directions_car", text:"&nbsp; &nbsp; 300 marques, &nbsp; &nbsp; 500 modèles"}, 
      {icon: "today", text:"&nbsp; Ramassage à domicile"}, 
      {icon: "flag_2", text:"1 jour d'éssai, Retours gratuits"}, 
      {icon: "settings_heart", text:"&nbsp;&nbsp; Bonus de &nbsp;&nbsp; fidélité"}
    ],
    "KEEP" : [
      {icon: "directions_car", text:"&nbsp; &nbsp; Accueil et  service premium"}, 
      {icon: "today", text:"&nbsp; Garantie 6 mois &nbsp;  et plus"}, 
      {icon: "flag_2", text:"&nbsp; &nbsp; Rappels de &nbsp; &nbsp; révision"}, 
      {icon: "settings_heart", text:"Véhicule de remplacement"}
    ]
  }

  constructor(
    private store: Store, 
    private router: Router) {

      this.businessLine$ = this.store.select(selectBusinessLine);
      
      this.makes$ = this.store.select(selectMakes);
      this.models$ = this.store.select(selectModels);
      this.versions$ = this.store.select(selectVersions);

      this.recentCarBriefs$ = store.select(selectRecentCarBriefs);
      this.defaultCountry = GeneralBasicData.getCountryByCode(AppConstants.COUNTRY_CODE_DEFAULT)!;

      this.selectedCountryCodes$ = store.select(selectSelectedCountryCodes);
      
      this.fetchingPreview$ = store.select(selectSearchFetchingPreview);

      this.carsPreviewTotalCount$ = store.select(selectAllSearchedCarsPreviewTotalCount);
      this.dealersPreviewTotalCount$ = store.select(selectAllSearchedDealersPreviewTotalCount);

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);
      
    }

  ngOnInit(): void {

    this.carMakesBD = CarBasicData.getMakesBD();
    this.countriesBD = GeneralBasicData.getAllCountries();

    this.store.dispatch(CarRefActions.makesFetchSubmit( {}));

    this.businessLine$.subscribe(
      (bsl: CarBusinessLine) => {
        if(bsl != undefined)
          this.carCriteria.businessLine = bsl;
        /*
        switch(bsl.toString()) {
          case CarBusinessLine.BUY : {
            this.carCriteria.businessLine = bsl;
            break;
          }

          case CarBusinessLine.RENT.toString() : {
            this.carCriteria.businessLine = bsl;
            break;          
          }

          case CarBusinessLine.KEEP.toString() : {
            this.carCriteria.businessLine = bsl;
            break;
          }
          default: { 
            break;
          }
        }  */
      }
    );

    this.selectedCountryCodes$.subscribe(
      (countryCodes) => {
        //this.selectedCountry = country;
        this.carCriteria.countries = countryCodes;
        this.updateCitiesSelector(); 
        if(this.isCarSearch()){
          this.store.dispatch(SearchActions.searchPreviewCriteriaSubmit( { carCriteria: JSON.parse(JSON.stringify(this.carCriteria)) }));
          this.store.dispatch(SearchActions.fetchRecentCarBriefsSubmit({countryCodes: this.carCriteria.countries, businessLine: this.carCriteria.businessLine!}));
        }
      }
    );

    this.recentCarBriefs$.subscribe(
      (res: CarBrief[]) =>  {
        this.recentCarBriefs = res.map(c => Object.assign(new CarBrief(), c));
      }
    ); 
    
    this.models$.subscribe(
      (models: CarModel[]) =>  {
        //this.selectedModels = models.filter(item => this.selectedModelsIds.includes(item.id));
        this.selectedModels = models.filter(model => this.selectedModels.findIndex(md => model.id == md.id) >= 0);
        this.carCriteria.models = this.selectedModels.map(item => item.name);
        this.onCriteriaChange();
      }
    ); 

    this.versions$.subscribe(
      (versions: CarVersion[]) =>  {
        //this.selectedModels = models.filter(item => this.selectedModelsIds.includes(item.id));
        this.selectedVersions = versions.filter(version => this.selectedVersions.findIndex(ver => version.id == ver.id) >= 0);
        this.carCriteria.versions = this.selectedVersions.map(item => item.name);
        this.onCriteriaChange();
      }
    ); 
  }

  getState(){
    return LocationService.getCurrentStateName();
  }

  getCountryName(code: string): string{
    return GeneralBasicData.getCountryByCode(code)?.name!;
  }

  goToSearchPage(make: string, model: string){

    let crt: CarCriteria = new CarCriteria();
    crt.makes = [make];
    crt.models = [model];
    //crt.businessLines = [this.selectedBusinessLine];

    this.router.navigate(
      ['/buy-car/search'],
      { queryParams: crt }
      );
  }

  updateModelsSelectorOld(): void{
    this.carCriteria.makes = this.selectedMakes.map(mk => mk.name);
    this.carCriteria.models = [];
    this.carModelsBD = CarBasicData.getModelsBD(this.carCriteria.makes);
  }

  updateCitiesSelector(): void{
    this.carCriteria.cities = [];
    this.citiesBD = GeneralBasicData.getAllCities(this.carCriteria.countries);
  }

  onBusinessLineChange() {
    if(this.isCarSearch()){
      this.store.dispatch(SearchActions.fetchRecentCarBriefsSubmit({countryCodes: this.carCriteria.countries, businessLine: this.carCriteria.businessLine!}));
    }   
    this.onCriteriaChange();
    this.store.dispatch(SearchActions.switchBusinessLine({businessLine: this.carCriteria.businessLine!}))
  }

  onMakesChange(mks: any){
    
    let makes: CarMake[] = (mks.length == undefined) ? [mks] : mks;
    //return
    this.carCriteria.makes = makes.map(item => item.name);
    this.carCriteria.models = [];
    this.carCriteria.versions = [];
    this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: makes.map(item => item.id) } ));
    //this.selectedModels.filter(md => this.carCriteria.makes.findIndex(mk => md.makeName == mk) >= 0);
  }

  onModelsChange(mds: any){

    let models: CarModel[] = (mds.length == undefined) ? [mds] : mds;

    this.carCriteria.models = models.map(item => item.name);
    this.carCriteria.versions = [];
    this.store.dispatch(CarRefActions.versionsFetchSubmit( { modelIds: models.map(item => item.id) } ));
    //this.onCriteriaChange();
  }

  onVersionsChange(vrs: any){

    let versions: CarVersion[] = (vrs.length == undefined) ? [vrs] : vrs;

    this.carCriteria.versions = versions.map(item => item.name);
    this.onCriteriaChange();
  }

  onCriteriaChange(){
    if(this.isCarSearch()){
      console.log(this.carCriteria);
      this.store.dispatch(SearchActions.searchPreviewCriteriaSubmit( { carCriteria: JSON.parse(JSON.stringify(this.carCriteria)) })); 
    }
    else{
      console.log(this.carCriteria);
      let crt: DealerCriteria = new DealerCriteria();
      crt.specialtyMakes = this.carCriteria.makes
      crt.servicesProvided =  [this.appointment.services.toString()]
      crt.countries = this.carCriteria.countries
      crt.cities = [this.carCriteria.cities.toString()]
      console.log(crt);
      this.store.dispatch(SearchActions.dealersPreviewCriteriaSubmit({dealerCriteria: JSON.parse(JSON.stringify(crt))}));
    }
  }

  submitSearchForm(){

    if(this.isCarSearch()){
      this.router.navigate(
        ['/'+this.carCriteria.businessLine!.toString().toLowerCase()+'/search'],
        { queryParams: JSON.parse(JSON.stringify(this.carCriteria)) }
        );
    }
    else{

      let crt: DealerCriteria = new DealerCriteria();
      crt.specialtyMakes = this.carCriteria.makes
      crt.servicesProvided = this.appointment.services
      crt.countries = this.carCriteria.countries
      crt.cities = this.carCriteria.cities

      this.router.navigate(
        ['/'+this.carCriteria.businessLine!.toString().toLowerCase()+'/search'],
        { queryParams: JSON.parse(JSON.stringify(crt)) }
      );

      /*
      this.appointment.carMake = this.carCriteria.makes[0];
      this.appointment.carModel = this.carCriteria.models[0];
      //this.appointment.car.city = (this.carCriteria.cities.length == undefined) ? this.carCriteria.cities : this.carCriteria.cities[0];
      //this.appointment.serviceTypes = this.carCriteria.;
      console.log(this.carCriteria.cities);
      console.log(this.appointment);

       this.router.navigate(
        //['/'+this.carCriteria.businessLine!.toString().toLowerCase()+'/appointment'],
        ['/'+this.carCriteria.businessLine!.toString().toLowerCase()+'/search'],
        { 
          queryParams: { 
            make: this.carCriteria.makes[0], 
            model: this.carCriteria.models[0], 
            country: this.carCriteria.countries[0],
            city: this.carCriteria.cities,
            services: this.appointment.services,
            categories: this.appointment.jobCategories
          } 
        }
        
      );
      */
    }
  }

  goToQuickLink(makes: string, models: string){
    let crt = new CarCriteria();
    crt.makes = [makes];
    crt.models = [models];
    crt.businessLine = this.carCriteria.businessLine;
    console.log(" criteria = "+crt)
    this.router.navigate(
      ['/'+this.carCriteria.businessLine!.toString().toLowerCase()+'/search'],
      { queryParams: crt }
      );
  }

  goToQuick(){
    let crt = new CarCriteria();
    crt.makes = [];
    crt.models = [];
    crt.businessLine = this.carCriteria.businessLine;
    console.log(" criteria = "+crt)
    this.router.navigate(
      ['/'+this.carCriteria.businessLine!.toString().toLowerCase()+'/search'],
      { queryParams: crt }
      );
  }

  getCarCriteriaQueryParams(make: string, model: string){
    let crt: CarCriteria = new CarCriteria();
    crt.makes = [make];
    crt.models = [model];
    return crt;
  }

  filterPastDates = (date: Date | null): boolean => {
    if ( ! (date! > this.yesterdayDate) ) {
      return false;
    } 
    return true;
  }

  onSelectedDatesChange(event: any, isEndDate: boolean){
    //console.log(isEndDate)
    if(isEndDate && this.carCriteria.startDate != null &&  this.carCriteria.startDate !== "" && this.carCriteria.endDate != null &&  this.carCriteria.endDate !== ""){
      //console.log('start '+ this.carCriteria.startDate);
      this.onCriteriaChange();
    }
  }

  isCarSearch = (): boolean => {
    return this.carCriteria.businessLine == CarBusinessLine.BUY || this.carCriteria.businessLine == CarBusinessLine.RENT;
  }
}
